import { FieldArray } from "formik";
import React from "react";
import FormikControl from "../FormikControl/FormikControl";
import _ from "lodash";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import useArrayGroupComponent from "./useArrayGroupComponent";

const ArrayGroupComponent = ({ inputArray, numberOfInsureds, productName }) => {
  // console.log("array: ", array);
  const { shouldRenderField } = useArrayGroupComponent();

  return (
    <>
      <FieldArray
        name={inputArray.name}
        render={(arrayHelpers) => {
          return (
            <div>
              {_.times(numberOfInsureds, (i) => {
                const objName = inputArray.name;
                const arrObjName = `${objName}[${i}]`;
                return (
                  <div key={i}>
                    <>
                      <h3 className="text-capitalize">
                        {inputArray.label} {i + 1}
                      </h3>
                    </>
                    {inputArray?.obj?.map((field, index) => {
                      const shouldRender = shouldRenderField(field, arrObjName);
                      const { name, ...rest } = field;
                      return shouldRender ? (
                        <div className="mb-3" key={index}>
                          <FormikControlContext.Provider
                            value={{
                              name: `${arrObjName}.${name}`,
                              arrObjName,
                              productName,
                              arrayIndex: i,
                              ...rest,
                            }}
                          >
                            <FormikControl />
                          </FormikControlContext.Provider>
                        </div>
                      ) : null;
                    })}
                  </div>
                );
              })}
            </div>
          );
        }}
      />
    </>
  );
};

export default ArrayGroupComponent;
